import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* createSmartGroup({ payload: { values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.modifiers.smartgroup.create, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.createSmartGroupDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.createSmartGroupFailed,
      handledErrors,
      endpoint: api.modifiers.smartgroup.create.url
    });
  }
}

export const createSmartGroupSaga = takeEvery(types.CREATE_SMART_GROUP_REQUEST, createSmartGroup);